import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('customer');
  const [phoneNumber, setPhoneNumber] = useState('');
  
  // Driver-specific fields
  const [vehicleBrand, setVehicleBrand] = useState('');
  const [vinNumber, setVinNumber] = useState('');
  const [driverLicenseNumber, setDriverLicenseNumber] = useState('');
  const [idNumber, setIdNumber] = useState('');
  const [trailerPlateNumber, setTrailerPlateNumber] = useState('');
  const [vehicleColor, setVehicleColor] = useState('');
  const [vehiclePlateNumber, setVehiclePlateNumber] = useState('');
  
  // File uploads
  const [vinImage, setVinImage] = useState(null);
  const [licenseImage, setLicenseImage] = useState(null);
  const [idImage, setIdImage] = useState(null);
  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append('full_name', fullName);
    formData.append('email', email);
    formData.append('password', password);
    formData.append('role', role);
    formData.append('phone_number', phoneNumber);
    
    if (role === 'driver') {
      formData.append('vehicle_brand', vehicleBrand);
      formData.append('vin_number', vinNumber);
      formData.append('driver_license_number', driverLicenseNumber);
      formData.append('id_number', idNumber);
      formData.append('trailer_plate_number', trailerPlateNumber);
      formData.append('vehicle_color', vehicleColor);
      formData.append('vehicle_plate_number', vehiclePlateNumber);
      if (vinImage) formData.append('vin_image', vinImage);
      if (licenseImage) formData.append('license_image', licenseImage);
      if (idImage) formData.append('id_image', idImage);
    }

    try {
      const response = await fetch('/auth/register', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSuccess('Registration successful! Please check your email for verification code.');
        setTimeout(() => navigate('/verify', { state: { email } }), 2000);
      } else {
        setError(data.message || 'Registration failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };




  return (
    <div style={{ position: 'relative', width: '100vw', minHeight: '100vh', overflowY: 'auto' }}>
      {/* Animated Aurora Background */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(-45deg, #5227FF, #7cff67, #5227FF, #FF6B6B)',
        backgroundSize: '400% 400%',
        animation: 'auroraFlow 15s ease infinite',
        zIndex: 0
      }} />

      {/* Transparent Glass Card */}
      <div style={{
        position: 'relative',
        maxWidth: '700px',
        margin: '40px auto',
        padding: '40px',
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        borderRadius: '20px',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255,255,255,0.3)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        zIndex: 1
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ color: '#eab308', fontSize: '28px', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>Create Account</h1>
          <p style={{ color: '#f0f0f0', textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}>Sign up for Van Trailer App</p>
        </div>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          {/* Full Name */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>FULL NAME</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="John Doe"
              required
              style={inputStyle}
            />
          </div>

          {/* Email */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="customer@example.com"
              required
              style={inputStyle}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={inputStyle}
            />
          </div>

          {/* Confirm Password */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>CONFIRM PASSWORD</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={inputStyle}
            />
          </div>

          {/* Phone Number */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>PHONE NUMBER</label>
            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="+27 123 456 789"
              required
              style={inputStyle}
            />
          </div>

          {/* Role Selection – Styled Cards */}
          <div style={{ marginBottom: '25px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '10px', fontWeight: '500' }}>REGISTER AS</label>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <div
                onClick={() => setRole('customer')}
                style={{
                  flex: 1,
                  padding: '12px',
                  textAlign: 'center',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  backgroundColor: role === 'customer' ? '#eab308' : 'rgba(255,255,255,0.15)',
                  color: role === 'customer' ? 'black' : 'white',
                  border: role === 'customer' ? '2px solid #eab308' : '1px solid rgba(255,255,255,0.3)',
                  transition: 'all 0.2s',
                  fontWeight: role === 'customer' ? 'bold' : 'normal'
                }}
              >
                👤 Customer
              </div>
              <div
                onClick={() => setRole('driver')}
                style={{
                  flex: 1,
                  padding: '12px',
                  textAlign: 'center',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  backgroundColor: role === 'driver' ? '#eab308' : 'rgba(255,255,255,0.15)',
                  color: role === 'driver' ? 'black' : 'white',
                  border: role === 'driver' ? '2px solid #eab308' : '1px solid rgba(255,255,255,0.3)',
                  transition: 'all 0.2s',
                  fontWeight: role === 'driver' ? 'bold' : 'normal'
                }}
              >
                🚚 Driver
              </div>
            </div>
          </div>

          {/* Driver-specific fields */}
          {role === 'driver' && (
            <>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>VEHICLE BRAND</label>
                <input type="text" value={vehicleBrand} onChange={(e) => setVehicleBrand(e.target.value)} required style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>VIN NUMBER</label>
                <input type="text" value={vinNumber} onChange={(e) => setVinNumber(e.target.value)} required style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>DRIVER'S LICENSE NUMBER</label>
                <input type="text" value={driverLicenseNumber} onChange={(e) => setDriverLicenseNumber(e.target.value)} required style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>ID NUMBER</label>
                <input type="text" value={idNumber} onChange={(e) => setIdNumber(e.target.value)} required style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>TRAILER PLATE NUMBER</label>
                <input type="text" value={trailerPlateNumber} onChange={(e) => setTrailerPlateNumber(e.target.value)} style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>VEHICLE COLOR</label>
                <input type="text" value={vehicleColor} onChange={(e) => setVehicleColor(e.target.value)} style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>VEHICLE PLATE NUMBER</label>
                <input type="text" value={vehiclePlateNumber} onChange={(e) => setVehiclePlateNumber(e.target.value)} required style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>UPLOAD VIN DOCUMENT (Image/PDF)</label>
                <input type="file" accept="image/jpeg,image/png,application/pdf" onChange={(e) => setVinImage(e.target.files[0])} style={{ ...inputStyle, padding: '6px' }} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>UPLOAD DRIVER'S LICENSE (Image/PDF)</label>
                <input type="file" accept="image/jpeg,image/png,application/pdf" onChange={(e) => setLicenseImage(e.target.files[0])} style={{ ...inputStyle, padding: '6px' }} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', fontWeight: '500' }}>UPLOAD ID DOCUMENT (Image/PDF)</label>
                <input type="file" accept="image/jpeg,image/png,application/pdf" onChange={(e) => setIdImage(e.target.files[0])} style={{ ...inputStyle, padding: '6px' }} />
              </div>
            </>
          )}

          {error && <div style={{ backgroundColor: 'rgba(220,38,38,0.3)', color: '#ffcccc', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center' }}>{error}</div>}
          {success && <div style={{ backgroundColor: 'rgba(16,185,129,0.3)', color: '#d1fae5', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center' }}>{success}</div>}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#eab308',
              color: 'black',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '16px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? 'CREATING ACCOUNT...' : 'REGISTER'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p style={{ color: '#f0f0f0', fontSize: '14px' }}>
            Already have an account?{' '}
            <span onClick={() => navigate('/login')} style={{ color: '#eab308', cursor: 'pointer', textDecoration: 'underline' }}>Sign In</span>
          </p>
        </div>
      </div>

      <style>{`
        @keyframes auroraFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
};

// Reusable input style (matches Login page)
const inputStyle = {
  width: '100%',
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid rgba(255,255,255,0.5)',
  backgroundColor: 'rgba(255,255,255,0.15)',
  color: 'white',
  fontSize: '14px',
  backdropFilter: 'blur(4px)',
  outline: 'none',
  boxSizing: 'border-box'
};

export default Register;
